module.exports = __webpack_public_path__ + "media/images/static/benefit/banner-82c7e26e729f7382531ca998b7cfd03f.png";